import loadScript from 'unified-navigation-ui/utils/loadScript';
import loadCriticalCSS from 'unified-navigation-ui/utils/loadCriticalCSS';
// @ts-expect-error legacy-hubspot-bender-context is a virtual, undeclared module
import { bender } from 'legacy-hubspot-bender-context';
import * as tempStorage from 'unified-navigation-ui/utils/tempStorage';
const smokeTestNavAsset = tempStorage.get('smokeTestNavAsset');
const loadAssets = smokeTestNavAsset || bender.depPathPrefixes[bender.project];
loadScript(`${bender.staticDomainPrefix}${loadAssets}/bundles/project.js`);
loadCriticalCSS();